<template>
    <section id="m_nav" class="m-nav-part">
        <transition name="el-fade-in-linear">
            <ul class="m-nav-con" v-show="isShow">
                <li v-for="(item ,index) in navArr" :key="item.id">
                    <span
                        v-if="item.type=='jump'"
                        :class="['js-aside-item', 'u-nav-item', active == index ? 'selected' : '']"
                        @click="navChange(item.href,$event,'',index)"
                        :data-id="item.href"
                        :data-num="index"
                    >{{item.title}}</span>

                    <a
                        v-else-if="item.type=='url'"
                        class="u-nav-item"
                        :href="[item.href?item.href:'javascript:;']"
                        :data-num="index"
                        target="_blank"
                    >{{item.title}}</a>
                </li>
                <span class="u-nav-item" alt="返回顶部" @click="runScroll">返回顶部</span>
            </ul>
        </transition>
    </section>
</template>
<script>
export default {
    name: "Nav",
    props: {
        navArr: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            isShow: false,
            active: 0
        };
    },
    mounted() {
        // this.navScroll();
        window.addEventListener("scroll", this.navScroll);
    },
    methods: {
        scrollTo(element, to, duration) {
            if (duration <= 0) return;
            var difference = to - element.scrollTop;
            var perTick = (difference / duration) * 10;

            setTimeout(function() {
                element.scrollTop = element.scrollTop + perTick;
                if (element.scrollTop == to) return;
                scrollTo(element, to, duration - 10);
            }, 10);
        },
        runScroll() {
            scrollTo(document.body, 0, 600);
        },
        navChange(selector, ele, type, index) {
            var el = type == "scroll" ? ele : ele.currentTarget;
            this.active = index;
            if (type != "scroll") {
                var distance = document.getElementById(selector).offsetTop;
                scrollTo(document.body, distance, 600);
            }
        },
        mouseScroll() {
            var navChoose = document.querySelectorAll(".nav_choose");
            var scroll =
                document.documentElement.scrollTop || document.body.scrollTop;
            var conID = "";
            for (var i = 0; i < navChoose.length; i++) {
                var top = navChoose[i].offsetTop;
                if (scroll >= top - 20) {
                    conID = navChoose[i].id;
                } else {
                    break;
                }
            }
            if (conID) {
                var ele = document.querySelector("span[data-id=" + conID + "]");

                if (ele) {
                    var num = ele.getAttribute("data-num");
                    this.navChange(conID, ele, "scroll", num);
                }
            }
        },
        navScroll() {
            var _this = this;
            var win = window;
            // win.onscroll = function(delay, callback) {
            if (win.scrollY > 500) {
                _this.isShow = true;
            } else {
                _this.isShow = false;
            }
            var timer = null;
            return (function() {
                var context = this;
                clearTimeout(timer);
                timer = setTimeout(function() {
                    _this.mouseScroll.call(context);
                }, 1000);
            })();
            // };
        }
    }
};
</script>
<style lang="scss" scoped>
.m-nav-part {
    // display: none;
    position: fixed;
    bottom: 10px;
    left: 50%;
    margin-left: -640px;
    z-index: 999;
    .m-nav-con {
        position: relative;
        padding-top: 50px;
        padding-bottom: 20px;
        &:after {
            position: absolute;
            top: 0;
            left: 5px;
            content: "";
            width: 1px;
            height: 100%;
            background: url("../images/nav_pic1.png") no-repeat;
            background-size: contain;
        }
    }
    .u-nav-item {
        display: block;
        margin-bottom: 30px;
        border-left: 5px solid transparent;
        padding-left: 25px;
        line-height: 20px;
        font-size: 20px;
        color: rgba(255, 255, 255, 0.7);
        text-align: left;
        cursor: pointer;
        &.selected {
            border-left: 5px solid #fff;
            color: #fff;
        }
    }
}
</style>